import { useLayoutEffect, useState } from 'react';

import { IconButton } from 'components/Blocks';
import { MoonIcon, SunIcon } from 'components/Icons';

import { cn } from 'styles';
import { createWebStorage } from 'utils/storage';

const { darkMode } = createWebStorage<{
  darkMode: boolean;
}>().init({
  darkMode: '______d___',
});

export function ColorModeButton() {
  const [isDark, setIsDark] = useState(darkMode.get());

  useLayoutEffect(() => {
    const enabled = darkMode.get();

    if (!enabled) return;

    document.body.classList.add('dark');
    setIsDark(true);
  }, []);

  const toggle = () => {
    setIsDark((old) => {
      const newRef = !old;

      if (newRef) {
        darkMode.set(true);
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
        darkMode.delete();
      }

      return newRef;
    });
  };

  return (
    <IconButton onClick={toggle}>
      <div className="h-4 w-4 overflow-hidden">
        {/* We use px as our font size reduces on smaller screens, reducing rem as well. TODO: Eval icon sizes in rem as well */}
        <SunIcon
          size={16}
          className={cn('transition-transform', isDark && '-translate-y-[16px]')}
        />
        <MoonIcon
          size={16}
          className={cn('transition-transform', isDark && '-translate-y-[16px]')}
        />
      </div>
    </IconButton>
  );
}
